<script setup lang="ts">
const appConfig = useAppConfig();
</script>

<template>
  <div class="cta bg-[url('~/assets/img/cta_bg-min.jpg')] overflow-hidden bg-cover bg-center p-14 rounded-xl relative max-md:p-5 max-md:pt-8 max-md:pb-0">
    <div class="flex items-center justify-end max-lg:flex-col-reverse">
      <div class="cta-img">
        <nuxt-img
          loading="lazy"
          src="/img/cta_img.webp"
          width="373"
          height="337"
          class="lg:absolute bottom-0 left-5"
          alt="CTA image"
          format="webp"
        />
      </div>
      <div class="flex flex-col gap-5 w-[535px] max-md:w-full">
        <p class="text-white text-4xl font-bold max-md:text-3xl max-md:font-semibold">
          Use Fictionme to <span class="text-primary">read novels online</span> anytime and anywhere
        </p>
        <p class="font-light text-lg text-[#EEEEEE] max-md:text-base">
          Enter the world where you can read some of the best romance novels, captivating werewolf stories and steamy fantasy tales.
        </p>
        <ul class="flex gap-3 justify-start items-center">
          <li>
            <a :href="appConfig.store.google" rel="nofollow" aria-label="play store">
              <nuxt-img
                  loading="lazy"
                  src="/img/gplay_b.svg"
                  width="157"
                  height="51"
                  alt="Google Play Store"
                  title="Download on the Google Play Store"
              />
            </a>
          </li>
          <li>
            <a :href="appConfig.store.apple" rel="nofollow" aria-label="app store">
              <nuxt-img
                  loading="lazy"
                  src="/img/appstore_b.svg"
                  width="156"
                  height="51"
                  alt="App Store"
                  title="Download on the App Store"
              />
            </a>
          </li>
        </ul>
      </div>
      <div class="qr-wrapper bg-white p-7 rounded-xl flex flex-col items-center justify-center gap-5 text-center ml-14 max-xl:hidden dark:bg-gray-950">
        <nuxt-img
            loading="lazy"
            src="/img/qr_download_cta.svg"
            width="120"
            height="120"
            alt="Scan QR"
            title="Scan QR"
        />
        <span>Scan the qr-code <br/> to download the app</span>
      </div>
    </div>
  </div>
</template>